import React from "react";
import { getProgramHeroContent } from "helpers/jackrabbit/getProgramHeroContent";
import { SCHEDULE_FILTER_HASH } from "helpers/jackrabbit/scheduleFilterSearchParams";
import defaultBanner from "assets/teamphotobannercopy.webp";
import "./ProgramPageHero.css";

const ProgramPageHero = ({
  displayName,
  pageTitle,
  imageSrc = defaultBanner,
  imageAlt,
  ctaHref = `#${SCHEDULE_FILTER_HASH}`,
}) => {
  const { eyebrow, titleLead, titleAccent, subtitle } = getProgramHeroContent(
    displayName,
    pageTitle
  );

  return (
    <section className="program-page-hero" aria-labelledby="program-page-hero-title">
      <img
        className="program-page-hero__image"
        src={imageSrc}
        alt={imageAlt || ""}
        width="1920"
        height="480"
      />
      <div className="program-page-hero__overlay" aria-hidden="true" />
      <div className="program-page-hero__content">
        <p className="program-page-hero__eyebrow">{eyebrow}</p>
        <h1 id="program-page-hero-title" className="program-page-hero__title">
          <span className="program-page-hero__title-lead">{titleLead}</span>
          {titleAccent && (
            <span className="program-page-hero__title-accent">{titleAccent}</span>
          )}
        </h1>
        <p className="program-page-hero__subtitle">{subtitle}</p>
        <a href={ctaHref} className="program-page-hero__cta">
          See class schedules
          <span aria-hidden="true"> ↓</span>
        </a>
      </div>
    </section>
  );
};

export default ProgramPageHero;
